import React from "react";
import { Dispatcher } from "./siteAboutInterfaces";
import { NavigateFunction } from "react-router-dom";
import { siteArmButtonDisableCheckRefresh } from "./siteArmButtonDisableCheckRefresh";
import { isTransitionalArmedStatus } from "../../SitesPage/SitesPageUtils/armedStatusPresentation";

/**
 * After any load / arm / disarm: keep the site's arm state fresh while a
 * command is still being applied.
 *
 * SUP-515: this used to LOCK the arm/disarm switch for as long as the site
 * reported ARMING or DISARMING. The backend can report DISARMING for a long
 * time while the site is in fact running and alerting (a stop followed by a
 * restart inside one census cycle), so the customer saw a greyed-out switch
 * and no way to disarm for 30 minutes. The switch now stays usable — in
 * ARMING it is ON so the only move is disarm, in DISARMING it is OFF so the
 * only move is arm — and we just poll until the state settles.
 */
export const checkArmedStatus = (
  siteInfo: any,
  setArmButtonDisabled: Dispatcher<boolean>,
  navigate: NavigateFunction,
  setSiteInfo: any,
  setArmedStatus: any,
  getIsMounted?: () => boolean
) => {
  setArmButtonDisabled(false);
  if (siteInfo.active && isTransitionalArmedStatus(siteInfo.armed_status)) {
    localStorage.setItem("armButtonCheckURL", window.location.pathname);
    siteArmButtonDisableCheckRefresh(
      siteInfo.id,
      setArmButtonDisabled,
      navigate,
      setSiteInfo,
      setArmedStatus,
      getIsMounted
    );
  }
};
